<template>
	<header class="page-header">
		<MBreadcrumb :items="breadcrumbItems" variant="user-center" />
	</header>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "~/composables/useI18n";
import MBreadcrumb from "~/components/m/breadcrumb/index.vue";

const I18N_NS = "masterFortune";
const { t } = useI18n();

const breadcrumbItems = computed(() => [
	{
		label: t(`${I18N_NS}.pageHeader.breadcrumbHome`),
		path: "/",
	},
	{
		label: t(`${I18N_NS}.pageHeader.breadcrumbCurrent`),
		disabled: true,
	},
]);
</script>

<style lang="scss" scoped>
.page-header {
	padding: 20px 32px 0;
	background: #ffffff;
}
</style>
